import { getCreateProjectHref } from 'base/blocks_routes';
import { Button } from 'base/ui/button';
import { Rows } from 'base/ui/layout';
import { TextMedium, TextTinyLight } from 'base/ui/typography';
import React from 'react';
import emptyStateHeroImage from './empty-state.webp';
import styles from './projects_panel.css';

export function NoProjectsEmptyState() {
  return (
    <div className={styles.emptyStateContainer}>
      <div className={styles.emptyStateContent}>
        <Rows xalign="center">
          <img
            className={styles.emptyStateImage}
            src={emptyStateHeroImage}
            alt="Empty project hero image"
          />
          <TextMedium>
            Design and build your next Webflow website using AI
          </TextMedium>
          <TextTinyLight color={'grey'}>
            Effortlessly generate sitemaps and wireframes for marketing websites
            in minutes, and paste them into Figma.
          </TextTinyLight>
          <Button
            label="Get Started"
            variant="primary"
            onClick={() => window.open(getCreateProjectHref(true), '_blank')}
          />
        </Rows>
      </div>
    </div>
  );
}
